import { useState } from "react";

export default function InformationOverlay({ item, clickTitle = null }) {
    const [isVisible, setIsVisible] = useState(false);

    if (!item || !item.name) return null;

    const toggleOverlay = () => setIsVisible(!isVisible);
    const closeOverlay = () => setIsVisible(false);

    const handleBackgroundClick = (e) => {
        if (e.target.classList.contains("overlay-with-box")) {
            closeOverlay();
        }
    };

    return (
        <>
            {!clickTitle ? (
                <span
                    className="curtains-icon curtains-icon-Info-circle size-26 show-overlay-btn gray"
                    onClick={toggleOverlay}
                ></span>
            ) : (
                <span
                    className="underline pointer color-bg2 show-overlay-btn"
                    onClick={toggleOverlay}
                >
                    {clickTitle}
                </span>
            )}

            {isVisible && (
                <div
                    className="overlay-with-box mobile-menu d-flex"
                    id={`${item.name}-info-overlay`}
                    onClick={handleBackgroundClick}
                >
                    <div className="overlay-box active-group flex-column pb-70 fit-content black mobile-menu-container sm-px-12">
                        <div className="width-550 sm-max-w-100">
                            <div className="row mb-54 sm-mb-24 flex-nowrap">
                                <div className="col">
                                    <h3 className="default-text" dangerouslySetInnerHTML={{__html: item.title}}></h3>
                                </div>
                                <div className="col-auto">
                                    <span
                                        className="curtains-icon curtains-icon-close size-24 pointer hide-overlay-btn"
                                        onClick={closeOverlay}
                                    ></span>
                                </div>
                            </div>

                            <div className="body-text3" dangerouslySetInnerHTML={{__html: item.text}}></div>

                            {item.imageUrl && (
                                <img
                                    src={item.imageUrl}
                                    alt={item.title}
                                    className="mt-54 sm-mt-24"
                                />
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
